//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React, { useState } from 'react';

import { ContentLibrarySourcesGroups } from '@apis/content-library/contentLibraryApiModel';
import { NestedCheckboxItem } from '@media-library/components/top-bar/DropdownNestedCheckbox';
import { NonBusinessTooltip } from '@media-library/components/top-bar/NonBusinessTooltip';
import { MediaLibrarySourcesDropdownGroup } from '@media-library/components/top-bar/sources-dropdown/MediaLibrarySourcesDropdownGroup';
import { MediaLibrarySourcesDropdownItemData } from '@media-library/components/top-bar/sources-dropdown/mediaLibrarySourcesDropdownConstants';
import { isUndefined } from '@utils/filterPredicates';

interface MediaLibrarySourcesDropdownItemProps {
  handleChangeSelect: (item: MediaLibrarySourcesDropdownItemData) => void;
  handleOpenModal: (sourcesGroup: ContentLibrarySourcesGroups) => void;
  searchTerm: string | undefined;
  source: MediaLibrarySourcesDropdownItemData;
}

export const MediaLibrarySourcesDropdownItem = ({
  handleChangeSelect,
  handleOpenModal,
  searchTerm = '',
  source,
}: MediaLibrarySourcesDropdownItemProps) => {
  const [shouldShowSubItems, setShouldShowSubItems] = useState<boolean>(true);

  const shouldShowCheckbox =
    searchTerm.length === 0 || isUndefined(source.subItems);
  const isNonBusinessUser = source.paramKey === 'trackedUserIds';

  return (
    <NestedCheckboxItem
      handleChangeSelect={handleChangeSelect}
      handleToggleShowSubItems={() => setShouldShowSubItems((prev) => !prev)}
      item={source}
      rightComponent={isNonBusinessUser ? <NonBusinessTooltip /> : undefined}
      shouldShowCheckbox={shouldShowCheckbox}
      shouldShowSubItems={shouldShowSubItems}
    >
      <MediaLibrarySourcesDropdownGroup
        handleChangeSelect={handleChangeSelect}
        handleOpenModal={handleOpenModal}
        searchTerm={searchTerm}
        source={source}
      />
    </NestedCheckboxItem>
  );
};
